"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protoClasses = void 0;
const DhtRpc_1 = require("../../generated/packages/dht/protos/DhtRpc");
exports.protoClasses = [
    DhtRpc_1.ClosestPeersRequest,
    DhtRpc_1.ClosestPeersResponse,
    DhtRpc_1.RecursiveOperationRequest,
    DhtRpc_1.RecursiveOperationResponse,
    DhtRpc_1.PingRequest,
    DhtRpc_1.PingResponse,
    DhtRpc_1.LeaveNotice,
    DhtRpc_1.PeerDescriptor,
    DhtRpc_1.ConnectivityMethod,
    DhtRpc_1.DisconnectNotice,
    DhtRpc_1.RouteMessageWrapper,
    DhtRpc_1.RouteMessageAck,
    DhtRpc_1.ConnectivityRequest,
    DhtRpc_1.ConnectivityResponse,
    DhtRpc_1.HandshakeRequest,
    DhtRpc_1.HandshakeResponse,
    DhtRpc_1.Message,
    DhtRpc_1.WebsocketConnectionRequest,
    DhtRpc_1.WebrtcConnectionRequest,
    DhtRpc_1.RtcOffer,
    DhtRpc_1.RtcAnswer,
    DhtRpc_1.IceCandidate,
    DhtRpc_1.LockRequest,
    DhtRpc_1.UnlockRequest,
    DhtRpc_1.LockResponse
];
//# sourceMappingURL=protoClasses.js.map